import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.label && !_ctx.editing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _renderSlot(_ctx.$slots, "label", { inputState: _ctx.inputState }, () => [
            _createElementVNode("label", null, _toDisplayString(_ctx.label), 1)
          ], true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["value", { 'static': _ctx.readonly || !_ctx.editing, editing: _ctx.editing}])
    }, [
      (!_ctx.editing)
        ? _renderSlot(_ctx.$slots, "static", {
            key: 0,
            inputState: _ctx.inputState
          }, () => [
            (_ctx.inputState.value && Array.isArray(_ctx.inputState.value))
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputState.value, (value, i) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      _createTextVNode(_toDisplayString(i > 0 ? ', ' : '') + _toDisplayString(value), 1)
                    ], 64))
                  }), 256))
                ]))
              : (_ctx.inputState.value && !Array.isArray(_ctx.inputState.value))
                ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.inputState.value), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, "-"))
          ], true)
        : _renderSlot(_ctx.$slots, "input", {
            key: 1,
            inputState: _ctx.inputState
          }, () => [
            (_ctx.editing)
              ? (_openBlock(), _createBlock(_component_q_select, _mergeProps({
                  key: 0,
                  modelValue: _ctx.inputState.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputState.value) = $event))
                }, _ctx.attributes, {
                  options: _ctx.optionsRef,
                  label: _ctx.label,
                  onFilter: _ctx.filterFn,
                  "popup-content-class": "select",
                  "fill-input": "",
                  borderless: "",
                  "emit-value": _ctx.emitValue,
                  dense: ""
                }), null, 16, ["modelValue", "options", "label", "onFilter", "emit-value"]))
              : _createCommentVNode("", true)
          ], true)
    ], 2)
  ], 64))
}